import { TileProp } from "../../constants/props";
import styles from "../../constants/styles";

const ImageWithTextTile = ({ heading, text, imageUrl }: TileProp) => {
  return (
    <div className="flex flex-col items-center p-4 md:p-9 rounded-xl bg-gray-100 h-fit">
      <div className="flex flex-col space-y-4 items-start w-full max-w-[400px]">
        <div className="text-left">
          <h2 className={styles.tertiaryHeading}>{heading}</h2>
          <span className={styles.standardText}>{text}</span>
        </div>
        <img alt="product" src={imageUrl} className="object-contain" />
      </div>
    </div>
  );
};

export default ImageWithTextTile;
